export default __webpack_public_path__ + "static/WDRMODE_0(2)-e591a77636a972e66a4e8282807d9a93.avif";